import { Protocol } from './_types';

export const LIB_PROTOCOL_STONE_HARVEST_SCREEN_EVAL: Protocol = {
    id: "stone_harvest_screen_eval",
    title: "Advanced Stone Fruit Harvest Evaluation",
    description: "Harvest evaluation is performed to characterise new cultivars and selections on the base of their fruit traits. Visual and sensory fruit evaluation are applied to describe fruit quality and keeping ability after storage over a specified storage period. Characteristics such as colour and pattern, shapes and symmetry, defects and disorders and eating quality are evaluated in detail.",
    sampleType: "harvest",

    chars: [
        "frut_ripe_stage",
        "frut_ripe_uniformity",
        "frut_firmness_homog",
        "frut_mature_rate",

        "frut_size",
        "frut_over_color",
        "frut_ground_color_stone",
        "frut_over_color_uniform",
        "frut_flesh_color",
        "frut_cavity_color",
        "frut_flesh_bleed",
        "frut_over_area",
        "frut_over_pattern",
        "frut_skin_bloom",
        "frut_pubescent",

        "frut_stone_adhesion",
        "frut_stone_size",
        "frut_flesh_type_stone",

        "frut_shape_type_stone",
        "frut_shape_symmetry",
        "frut_shape_consistent",
        "frut_pendicul_depth",
        "frut_pendicul_width",
        "frut_pendicul_tear",
        "frut_calyx_depth",
        "frut_calyx_width",
        "frut_calyx_tip",
        "frut_calyx_soft",
        "frut_pestilar_split",
        "frut_suture",

        "frut_abrasion",
        "frut_blemish",
        "frut_russet",
        "frut_russet_type",
        "frut_pestilar_russet",
        "frut_lenticel",
        "frut_spot",
        "frut_sugarspot",

        "frut_taste_sugar",
        "frut_taste_acid",
        "frut_taste_balance",
        "frut_taste_aroma",
        "frut_taste_juice",
        "frut_skin_thick",
        "frut_text_firm",
        "frut_text_crisp",
        "frut_text_crunch",
        "frut_text_grain",

        "frut_disease_stone",
        "frut_extdisorder_stone",
        "frut_shrivel_symptom",
        "frut_intdisorder_stone",
        "frut_woolli_symptom",
        "frut_pulp_symptom",
        "frut_sponge_symptom",
        "frut_rubber_symptom",
        "frut_gelbreak_symptom",
        "frut_intbrown_symptom",
        "frut_intbreak_symptom",
        "frut_shrivelling_severity",
        "frut_disorder_inking",
        "frut_disorder_inking_se",

        "frut_overall_keepqual",
        "frut_overall_appear",
        "frut_overall_color",
        "frut_overall_texture",
        "frut_overall_taste",
        "frut_overall_eatqual",
        "frut_overall_interest"
    ],

    measures: [
        "frut_length",
        "frut_weight",
        "frut_diameter",
        "frut_firmness",
        "frut_tss",
        "frut_acid",
        "frut_acid_citric",
        "frut_acid_tart",
        "frut_juiciness",
        "frut_cheek_1",
        "frut_cheek_2",
        "frut_shoulder",
        "frut_suture",
        "frut_tip",
        "frut_disease_shrivel",
        "frut_disease_bruising",
        "frut_disease_gel_breakdown",
        "frut_internal_browning",
        "frut_inking",
        "frut_sugar_spots",
        "frut_stem_decay",
    ],

    calculations: [
        "sugar_acid_ratio_calc",
        "frut_disease_none_calc",
        "frut_disease_low_calc",
        "frut_disease_med_calc",
        "frut_disease_high_calc",
        "frut_weight_classification_eu",
        "frut_weight_classification_us",
    ],

    indexes: [
        "indx_frut_eating_quality",
        "indx_frut_overall"
    ],

}